import React from 'lib/react';
import PropTypes from 'prop-types';
import {
  EVGrid, EVTypography, EVButton, EVInfoOutlinedIcon,
} from 'lib/components';
import { Link } from 'lib/router';
import { SUPPORT_ROUTE } from 'constants/RouteConstants';
import SitemapApprovalStructureItem from './SitemapApprovalStructureItem.component';

function SitemapApprovalSidebar({
  classes,
  totalCount,
  structures,
  selectedIds,
  onToggleStructure,
  onSubmit,
  submitting,
}) {
  const selectedCount = selectedIds.length;

  return (
    <>
      <EVTypography className={classes.sidebarTitle}>Selected Structures</EVTypography>
      <EVTypography className={classes.sidebarCount}>
        {`${selectedCount} OF ${totalCount} STRUCTURES`}
      </EVTypography>

      {totalCount === 0 && (
        <EVTypography className={classes.emptySelection}>
          No structures available
        </EVTypography>
      )}

      <EVGrid className={classes.infoBox}>
        <EVInfoOutlinedIcon className={classes.infoIcon} />
        <EVTypography className={classes.infoText}>
          Each selected structure will generate a measurement report to be processed and billed
          separately. Questions?
          {' '}
          <Link to={SUPPORT_ROUTE} className={classes.contactLink}>Contact us</Link>
          .
        </EVTypography>
      </EVGrid>

      {totalCount > 0 && (
        <EVGrid className={classes.structureList}>
          {structures.map((structure) => (
            <SitemapApprovalStructureItem
              key={structure.id}
              buildingId={structure.id}
              address={structure.address}
              index={structure.id - 1}
              checked={selectedIds.includes(structure.id)}
              onToggle={() => onToggleStructure(structure.id)}
            />
          ))}
        </EVGrid>
      )}

      <EVGrid className={classes.sidebarFooter}>
        <EVGrid className={classes.measurementRow}>
          <EVTypography className={classes.measurementLabel}>Measurement Reports</EVTypography>
          <EVTypography className={classes.measurementCount}>{selectedCount}</EVTypography>
        </EVGrid>
        <EVButton
          color="primary"
          variant="contained"
          fullWidth
          className={classes.submitButton}
          disabled={selectedCount === 0 || submitting}
          onClick={onSubmit}
        >
          {submitting ? 'Submitting…' : 'Submit'}
        </EVButton>
        <EVTypography className={classes.submitHint}>
          Clicking &apos;Submit&apos; will confirm your selected structures
        </EVTypography>
      </EVGrid>
    </>
  );
}

SitemapApprovalSidebar.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  totalCount: PropTypes.number.isRequired,
  structures: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    address: PropTypes.string.isRequired,
  })).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onToggleStructure: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

SitemapApprovalSidebar.defaultProps = {
  submitting: false,
};

export default SitemapApprovalSidebar;
